import { getUrl } from 'aws-amplify/storage';
import { getFullBucketName, S3Bucket } from '../config/constants';
import { useEffect, useState } from 'react';

const getAmplifyFileUrl = async ({
  bucket,
  path,
  downloadAs
}: {
  bucket: S3Bucket;
  path: string;
  downloadAs?: string;
}) => {
  const urlResult = await getUrl({
    path,
    options: {
      bucket: getFullBucketName(bucket),
      expiresIn: 7200,
      // S3 serves the object as an attachment, so the browser always downloads.
      ...(downloadAs && {
        contentDisposition: { type: 'attachment', filename: downloadAs }
      })
    }
  });

  return urlResult;
};

type UseProps = {
  bucket: S3Bucket;
  path: string | undefined | null;
  downloadAs?: string;
};

export const useAmplifyFileURL = ({ path, bucket, downloadAs }: UseProps) => {
  const key = bucket + path + (downloadAs ?? '');

  const [data, setData] = useState<{
    key: string;
    url: URL | null;
  }>();

  useEffect(() => {
    const fetchUrl = async () => {
      if (data?.key === key || !path) return;
      const urlResult = await getAmplifyFileUrl({
        bucket,
        path,
        downloadAs
      });

      setData({
        key,
        url: urlResult.url
      });
    };

    fetchUrl();
  }, [key]);

  return {
    url: key === data?.key ? data?.url : undefined
  };
};
